import React from 'react';
import { SvgIcon } from '@mui/material';
import { ReactComponent as StatusDotRed } from 'assets/images/icons/dots/statusdot-red.svg';
import { IconProps } from 'types/icon';

const StatusDotRedIcon: React.FC<IconProps> = ({
    width = '18px',
    height = '18px',
}) => {
    return (
        <SvgIcon
            component={StatusDotRed}
            inheritViewBox
            style={{ width, height }}
        />
    );
};

export default StatusDotRedIcon;
